import { useMemo, useState } from 'react';
import {
  MaterialReactTable,
  type MRT_ColumnDef,
  type MRT_Row,
  useMaterialReactTable,
} from 'material-react-table';

import {
  QueryClient,
  QueryClientProvider,
  useQuery,  
} from '@tanstack/react-query';

import { IReportViewData } from './ReportViewData';
import { useNavigate } from 'react-router-dom';
import { AxiosInstance } from '../../api/apiInstance';
import { muiTableBodyCellPropsHelper, muiTableHeadCellPropsHelper } from '../../helper/helper';


const ReportView = () => {
  const navigate = useNavigate();
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});
  //const [allData, setAllData] = useState<IReportViewData[]>();

  const columns = useMemo<MRT_ColumnDef<IReportViewData>[]>(
    () => [      
      {
        accessorKey: 'reportName',
        header: 'report Name',
      },
      {
        accessorKey: 'reportTitleName',
        header: 'report Title Name',        
      },
    ],
    [],
  );

  //call READ hook
  const {
    data: fetchedReports = [] as IReportViewData[],
    isError: isLoadingreportsError,
    isFetching: isFetchingreports,
    isLoading: isLoadingreports,
  } = useGetReports();


  //READ hook (get reports from api)
function useGetReports() {
  return useQuery<IReportViewData[]>({
    queryKey: ['reports'],
    queryFn: async () => {
      //send api request here
      return await AxiosInstance({
        // url of the api endpoint (can be changed)
        url: "report-view",
        method: "GET",
      }).then((res) => {
        // handle success
        return res.data as IReportViewData[];
      });   
    },
    refetchOnWindowFocus: false,
  });
}
    const openOrderLines = (row: MRT_Row<IReportViewData>) => {    
      navigate('reportsInfo/' + row._valuesCache.reportName)      
    };
   
  const table = useMaterialReactTable({
    enableDensityToggle:false,  
    enableHiding: false,
    enableColumnActions: false,
    enablePagination: false,
    enableRowActions: true,
   
    enableSorting:false,
    enableBottomToolbar:false,
    enableColumnFilters:false,
    enableColumnOrdering:false,
    enableColumnFilterModes:false,  
    enableFilterMatchHighlighting:false,
    enableGlobalFilter:true,
    enableFullScreenToggle: false,

    autoResetPageIndex: false,
    enableRowOrdering: false,
    
    columns,
    //enableRowActions:true,
    data: fetchedReports,
    createDisplayMode: 'modal', //default ('row', and 'custom' are also available)
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)
    enableEditing: false,
    getRowId: (row) => row.id,
    enableRowDragging: false,
    initialState: {  density: 'compact' },
    muiTableBodyProps: {
      sx: {
        //stripe the rows, make odd rows a darker color
        '& tr:nth-of-type(odd) > td': {
          backgroundColor: '#f5f5f5',
        },
      },
    },
    muiToolbarAlertBannerProps: isLoadingreportsError
    ? {
        color: 'error',
        children: 'Error loading data',
      }
    : undefined,
    state: {
      isLoading: isLoadingreports,
      showAlertBanner: isLoadingreportsError,
      showProgressBars: isFetchingreports,
    },
    muiTableHeadCellProps: {
          //no useTheme hook needed, just use the `sx` prop with the theme callback
          sx: (theme) => (muiTableHeadCellPropsHelper),
        }, 
    muiTableBodyCellProps: ({ column }) => ({
      //conditionally style pinned columns
      sx: {
        muiTableBodyCellPropsHelper
      },
    }),

          
    muiTableContainerProps: {
      sx: {
        minHeight: '500px',
        padding: '1rem',
        margin: '1rem',
      },
    },
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => {
        openOrderLines(row)
      },
      sx: {
        cursor: 'pointer', //you might want to change the cursor too when adding an onClick
      },
    }),  
      });

  return <MaterialReactTable table={table} />;
};


const queryClient = new QueryClient();

const ExampleWithProviders = () => (
  //Put this with your other react-query providers near root of your app
  <QueryClientProvider client={queryClient}>
    <ReportView />
  </QueryClientProvider>
);

export default ExampleWithProviders;

